import { render, staticRenderFns } from "./Counpon.vue?vue&type=template&id=adc36768&scoped=true&"
import script from "./coupon.js?vue&type=script&lang=js&"
export * from "./coupon.js?vue&type=script&lang=js&"
import style0 from "./coupon.scss?vue&type=style&index=0&id=adc36768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc36768",
  null
  
)

export default component.exports